import React from 'react'
import { connect } from 'react-redux'

import AutoComplete from '../common/autoComplete'

import { fetchCities } from './actions'

function hightLightText(str, val) {
  var index = str.toLowerCase().indexOf(val.toLowerCase());
  if(index > 0) {
    return [
      str.substring(0, index),
      <b key={1} style={{ color: '#000' }}>{val}</b>,
      str.substring(index+val.length),
    ];
  } else if(index === 0) {
    return [
      <b key={1} style={{ color: '#000' }}>{str.substring(0, index+val.length)}</b>,
      str.substring(index+val.length)
    ];
  }
  return str;
}

const renderElements = function (item, value) {
  return (
    <div className='cursor'>
     <p className='cityStyle'>
        {
          value ?
            hightLightText(item.city_name || item.display_name, value)
          : item.city_name
        }
        {(item.is_multi_district && item.district) ? ` (${item.district})` : ''}
      </p>
      <p className='stateStyle'>{item.state || ''}</p>
    </div>
  );
};

class CitySearch extends React.Component {

  constructor() {
    super();
    this.state = {

    }
  }

  onChange = (value) => {
    this.props.fetchCities(value);
  }

  onItemSelect = (item) => {
    this.props.onSelect(item);
  }

  render() {
    const { placeholder, isDisabled, defaultValue, fieldName, cityData=[] } = this.props;
    return (
      <AutoComplete
        name={fieldName}
        openOnFocus={true}
        listData={cityData}
        fieldName={fieldName}
        isDisabled={isDisabled}
        placeholder={placeholder}
        defaultValue={defaultValue}
        renderElements={renderElements}
        onChange={this.onChange}
        onSelect={this.onItemSelect}
      />
    )
  }
}

const mapStateToProps = store => ({
  cityData: store.citySearchAutoCompleteReducer.cityData,
})

const mapDispatchToProps = dispatch => ({
  fetchCities: (queryStr) => dispatch(fetchCities(queryStr))
})

CitySearch.propTypes = {}

export default connect(mapStateToProps, mapDispatchToProps)(CitySearch)
